"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ATTR_LAST_NAME = exports.ATTR_FIRST_NAME = exports.ATTR_SOURCE = exports.ATTR_EXP = exports.ATTR_NUMBER = exports.ATTR_CVV = exports.ATTR_CARD_ID = exports.SOURCE_MANUAL = exports.SOURCE_WALLET = void 0;

/* eslint one-var: "off" */
var SOURCE_WALLET = 'wallet';
exports.SOURCE_WALLET = SOURCE_WALLET;
var SOURCE_MANUAL = 'manual';
exports.SOURCE_MANUAL = SOURCE_MANUAL;
var ATTR_CARD_ID = 'cardId';
exports.ATTR_CARD_ID = ATTR_CARD_ID;
var ATTR_CVV = 'cvv';
exports.ATTR_CVV = ATTR_CVV;
var ATTR_NUMBER = 'number';
exports.ATTR_NUMBER = ATTR_NUMBER;
var ATTR_EXP = 'expire';
exports.ATTR_EXP = ATTR_EXP;
var ATTR_SOURCE = 'source';
exports.ATTR_SOURCE = ATTR_SOURCE;
var ATTR_FIRST_NAME = 'firstName';
exports.ATTR_FIRST_NAME = ATTR_FIRST_NAME;
var ATTR_LAST_NAME = 'lastName';
exports.ATTR_LAST_NAME = ATTR_LAST_NAME;